import React, { ReactNode } from "react";

import { faMousePointer } from "@fortawesome/pro-solid-svg-icons/faMousePointer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { defineMessages, useIntl } from "react-intl";

import ButtonLink from "@app/component/ButtonLink";
import RoundButton from "@app/component/RoundButton";
import useClickTracker from "@app/util/contexts/useClickTracker";
import { formatLink } from "@app/util/formatters";

interface Props {
  asLink?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  tooltip?: ReactNode;
  trackKey?: string;
  url?: null | string;
}

const messages = defineMessages({
  website: {
    id: "actions.visitWebsite",
    defaultMessage: "Visit website",
    description: "Visit website action label",
  },
});

const VisitWebsite = ({ asLink, disabled, onClick, tooltip, trackKey, url }: Props) => {
  const intl = useIntl();

  const isDisabled = disabled || !url;

  const handleClick = useClickTracker({
    disabled: isDisabled,
    onClick,
    trackKey,
  });

  return (
    <Tooltip placement="bottom" title={tooltip} trigger={tooltip ? ["hover"] : []}>
      <div>
        {asLink ? (
          <ButtonLink
            disabled={isDisabled}
            href={url ? formatLink(url) : undefined}
            onClick={handleClick}
            rel="noopener noreferrer"
            target="_blank"
          >
            {intl.formatMessage(messages.website)}
          </ButtonLink>
        ) : (
          <RoundButton
            disabled={isDisabled}
            href={url ? formatLink(url) : undefined}
            icon={<FontAwesomeIcon icon={faMousePointer} />}
            onClick={handleClick}
            rel="noopener noreferrer"
            target="_blank"
          >
            {intl.formatMessage(messages.website)}
          </RoundButton>
        )}
      </div>
    </Tooltip>
  );
};

export default VisitWebsite;
